
<div class="assign-button">
    <a @click.stop="onPlus" v-if="plusActive">
        <v-icon
            :color = "hasAssignableEntries ? 'success' : 'secondary'"
            class  = "toolbar-button"
            size   = "20"
        >
            mdi-plus-box
        </v-icon>
    </a>

    <a @click.stop="onMinus" v-if="minusActive">
        <v-icon
            :color = "hasDissolvableEntries ? 'red' : 'secondary'"
            class  = "toolbar-button"
            size   = "20"
        >
            mdi-minus-box
        </v-icon>
    </a>
</div>
